import "../styles/PrivacyPolicy.css";

export default function PrivacyPolicy() {
  return (
    <div className="privacy-container">
      <h1>Privacy Policy</h1>
      <p className="privacy-meta">Last updated: August 1, 2025</p>

      <p>
        Niña Kheaney Linares built the <strong>Waste Map</strong> app as a free application.
        This SERVICE is provided by Niña Kheaney Linares at no cost and is intended for use as is.
      </p>

      <h2>Information Collection and Use</h2>
      <p>
        We do <strong>not collect any personally identifiable information</strong> from users of the Waste Map app.
        However, the app does use <strong>third-party services</strong> that may collect information used to identify you.
      </p>
      <p>Third-party services used by the app may include:</p>
      <ul>
        <li>
          <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
            Google Play Services
          </a>
        </li>
        <li>
          <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer">
            Firebase
          </a>
        </li>
      </ul>

      <h2>Log Data</h2>
      <p>
        In case of an error in the app, we may collect data and information (through third-party products) on your phone
        called <strong>Log Data</strong>. This may include your device’s IP address, device name, OS version, app configuration, and the time and date of your use.
      </p>

      <h2>Cookies</h2>
      <p>
        This app does not use cookies explicitly. However, third-party services may use cookies to collect and improve their services.
      </p>

      <h2>Security</h2>
      <p>
        We value your trust in using our Service. While we strive to use commercially acceptable means of protecting it,
        remember that <strong>no method of transmission over the internet is 100% secure</strong>.
      </p>

      <h2>Children’s Privacy</h2>
      <p>
        The app is <strong>not intended for children under the age of 13</strong>. We do not knowingly collect personally identifiable information from children.
      </p>

      <h2>Changes to This Privacy Policy</h2>
      <p>
        We may update our Privacy Policy from time to time. You are advised to review this page periodically for any changes.
        We will notify you by updating the policy on this page.
      </p>
      <p>This policy is effective as of <strong>August 1, 2025</strong>.</p>

      <h2>Contact Us</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy, feel free to contact:
      </p>
      <ul>
        <li>
          Email: <a href="mailto:nina@itransact.nl">nina@itransact.nl</a>
        </li>
        <li>
          Website: <a href="https://expo-waste-map-ifn5.vercel.app/">https://expo-waste-map-ifn5.vercel.app/</a>
        </li>
      </ul>
    </div>
  );
}
